import React, { useContext, useState, useEffect } from 'react';
import { cloneDeep } from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import {
  Layout,
  Select,
  Tabs,
  Input,
  Row,
  Col,
  Popconfirm,
  Upload,
  Button,
  Card,
  List,
  Progress,
} from 'antd';
import {
  DollarCircleOutlined,
  DeleteOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import TeamsTab from './TeamsTab';
import { StoreContext } from '../store/index';
import { onCollectionChange, getLeagueDateFromTimestamp } from '../utils';
import { VIEW, STATE, SPORTS } from '../constants';

const League = ({ league }) => {
  const store = useContext(StoreContext);
  const {
    user: [user],
    sports: [sports],
  } = store;

  console.log(league);
  const { id, name, isFinished, price, startDate, description } = league;

  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const { Search } = Input;
  const { Option } = Select;
  const { Content } = Layout;
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [leaguesChanged, setLeaguesChanged] = useState(false);
  const [stateFilter, setStateFilter] = useState(STATE.IN);

  useEffect(() => {
    onCollectionChange('leagues', setLeaguesChanged);
  }, []);

  useEffect(() => {}, [leaguesChanged]);

  return (
    <Card
      key={id}
      className="card"
      title={
        <Row align="middle" style={{ marginBottom: '4px' }}>
          <Col xs={16}>
            <Row>{isFinished ?? formatMessage({ id: 'shifts.finished' })}</Row>
            {!isFinished && startDate < new Date() && (
              <>
                <Row>
                  {`${formatMessage({
                    id: 'leagues.title.date.register',
                  })}
                  ${getLeagueDateFromTimestamp(
                    league.paymentMaxDate,
                    user.languageSelected,
                  )}`}
                </Row>
                <Row>
                  <DollarCircleOutlined
                    style={{ fontSize: '20px', paddingRight: '4px' }}
                  />
                  {`${price}€`}
                </Row>
              </>
            )}
          </Col>
          <Col xs={8}>
            {league.userId === user.uid && (
              <Row style={{ marginTop: '4px' }}>
                <Popconfirm
                  title={formatMessage({ id: 'shifts.actions.delete.confirm' })}
                  description={formatMessage({
                    id: 'common.actions.confirm.question',
                  })}
                  onConfirm={() => console.log(id, setLoading)}
                  onCancel={() => {}}
                  okText={formatMessage({ id: 'common.yes' })}
                  cancelText={formatMessage({ id: 'common.no' })}>
                  <Button
                    style={{ width: '100%' }}
                    danger
                    loading={loading}
                    icon={<DeleteOutlined />}>
                    {formatMessage({ id: 'common.actions.delete' })}
                  </Button>
                </Popconfirm>
              </Row>
            )}
          </Col>
        </Row>
      }>
      <Row justify="space-between" className="width100">
        <Tabs
          className="width100"
          items={[
            {
              key: 1,
              label: formatMessage({ id: 'shifts.teams' }),
              children: <TeamsTab league={league} />,
            },
            {
              key: 2,
              label: formatMessage({ id: 'leagues.scoreboard' }),
              children: <Row>lista</Row>,
            },
            {
              key: 3,
              label: formatMessage({ id: 'leagues.games' }),
              children: <Row>lista</Row>,
            },
          ]}
        />
      </Row>
      <span>{description}</span>
    </Card>
  );
};

export default League;
